import { formatTagsData, getDefaultWidgetName } from "utils/utils";
import { NormalizedWidgetFormStrings } from "constants/constantStrings";
import { NORMALIZED_FILTERS } from "constants/report.constant";
import { WIDGET_TYPES } from "constants/widgets.type.const";

const NormalizedFilterFields = [
  { id: NORMALIZED_FILTERS.production, name: "Recovery" },
  { id: NORMALIZED_FILTERS.feedFlow, name: "FeedFlow" },
  { id: NORMALIZED_FILTERS.conductivity, name: "RejectConductivity" }
];

const getChildItem = (filterItem, type) => ({
  label: NormalizedWidgetFormStrings[type],
  name: `${filterItem.name}${type}`,
  value: "",
  error: null
});

const inputBoxesConfig = NormalizedFilterFields.map(filterItem => ({
  ...filterItem,
  error: null,
  child: [getChildItem(filterItem, "L"), getChildItem(filterItem, "H")]
}));

const getInputBoxsConfig = values => {
  const data = JSON.parse(JSON.stringify(inputBoxesConfig));
  if (values) {
    data.forEach(({ child }) => {
      child.forEach(filterItem => (filterItem.value = values[filterItem.name]?.toString()));
    });
  }
  return data;
};

const parseInputVal = source =>
  source.reduce((result, filter) => {
    filter.child.forEach(({ name, value }) => (result[name] = value));
    return result;
  }, {});

const getWidgetDefaultState = (Header, Tags, Comments) => ({
  Header: Header || getDefaultWidgetName(),
  ...formatTagsData(Tags),
  Baseline: null,
  Comments: Comments || ""
});

const getTagsConfig = () => {
  const noOfTags = 3;
  const tagsList = new Array(noOfTags).fill("Tag");
  return tagsList.map((tag, idx) => ({ id: `Tag${idx + 1}`, value: null, required: idx === 0 }));
};

const getItemByName = (filterName, tempData) => {
  const field = filterName.slice(0, filterName.length - 1);
  const item = tempData.find(({ name }) => name === field);
  const childKey = item?.child.findIndex(({ name }) => name === filterName);
  return { item, childKey };
};

const getPayload = (widgetData, currentLayout, filtersData, isChartView) => {
  const { Header, Tag1, Tag2, Tag3, Baseline, Comments } = widgetData;
  let payload = {};
  if (!isChartView) {
    const Type = WIDGET_TYPES.NORMALIZATION;
    const SystemTag = [Tag1, Tag2, Tag3].filter(tag => tag).map(({ TagId }) => TagId);
    payload = {
      Header,
      Type,
      LayoutID: currentLayout.ID,
      Attributes: { SystemTag: SystemTag, Comments: Comments || "", Baseline: Baseline.Id, ...filtersData }
    };
  } else {
    payload = { Tag1: Tag1?.TagId, Baseline: Baseline.Id, ...filtersData };
  }
  return payload;
};

export const formatNormalizeFilters = NormalizationFilters => {
  const filtersData = { FeedFlow: null, Recovery: null, RejectConductivity: null };
  if (NormalizationFilters.FeedFlowL && NormalizationFilters.FeedFlowH) {
    filtersData.FeedFlow = {
      Low: NormalizationFilters.FeedFlowL,
      High: NormalizationFilters.FeedFlowH
    };
  }
  if (NormalizationFilters.RecoveryL && NormalizationFilters.RecoveryH) {
    filtersData.Recovery = {
      Low: NormalizationFilters.RecoveryL,
      High: NormalizationFilters.RecoveryH
    };
  }
  if (NormalizationFilters.RejectConductivityL && NormalizationFilters.RejectConductivityH) {
    filtersData.RejectConductivity = {
      Low: NormalizationFilters.RejectConductivityL,
      High: NormalizationFilters.RejectConductivityH
    };
  }
  return filtersData;
};

const NormalizedUtil = {
  getWidgetDefaultState,
  parseInputVal,
  getInputBoxsConfig,
  getPayload,
  getItemByName,
  getTagsConfig,
  formatNormalizeFilters
};

export default NormalizedUtil;
